import { reactive } from 'vue';

export const criarFrotaAlerta = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamento: 0,
        idequipamentogrupo: 0,
        idequipamentosetor: 0,
        cdalerta: 0,
        nmalerta: '',
        lsenderecos: '',
        ativo: 'S',
        idlogin: 0
    });
};